"use client";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui";
import type { Session } from "next-auth";

export type AuthUserAvatarProps = {
  user: Session["user"];
};

export const AuthUserAvatar = ({ user }: AuthUserAvatarProps) => {
  const image = user.image?.trim();
  const initial = user.name?.trim()?.charAt(0)?.toUpperCase();

  return (
    <Avatar className="size-9 shrink-0 bg-primary text-primary-foreground dark:bg-dark-elevated">
      {image ? <AvatarImage src={image} alt="" /> : null}
      <AvatarFallback className="bg-primary text-primary-foreground dark:bg-card dark:text-card-foreground">
        {initial ?? "?"}
      </AvatarFallback>
    </Avatar>
  );
};
